<template>
	<div class="choose-dac">
		<egranty-section-divider
			text="Kody DAC"
			icon="assignment"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>

		<offer-button
			class="ml-4 white--text no-print"
			v-if="!readonly"
			:text="choosen.length === 0 ? 'Dodaj kod DAC' : 'Dodaj kolejny kod DAC'"
			icon="add"
		></offer-button>

		<offer-button
			class="lightred no-print"
			v-if="choosen.length && !readonly"
			@click="clear"
			icon="delete"
			text="Usuń wszystkie"
		></offer-button>

		<egranty-autocomplete
			class="no-print"
			style="background-color: primary"
			:is-visible.sync="addDacOpen"
			:headers="headers"
			:possibilities="possibilities"
			title="Dodaj nowy kod DAC"
			hint=""
			search-field-label="Kod DAC"
			:filters="filters"
			:description="(x) => x.code + ' - ' + x.description"
			@cancel="addDacOpen = false"
			@save="add"
		></egranty-autocomplete>

		<v-flex sm12 ml-3 py-3>
			<v-layout
				align-baseline=true
				row
				:key='index'
				v-for="(val,index) in  choosen"
			>
				<v-flex sm6><strong>{{val.code}} - {{val.description}}</strong></v-flex>
				<v-flex sm2 v-if="choosen[1] !== undefined && !readonly">
					<v-slider
						:disabled="readonly"
						v-model='val.value'
						:max=100
						@input="edit(index)"
					></v-slider>
				</v-flex>
				<v-flex xs1 v-if="!readonly">
					<egranty-icon-button
						large
						icon="delete"
						label="Usuń"
						@click="deleteElem(index)"
					/>
				</v-flex>
				<input
					:disabled="readonly"
					type="number"
					value="value"
					v-model="val.value"
					v-if="choosen[1] !== undefined && !readonly"
					:min="0"
					:max="100"
					@input="editText(index)"
					style="text-align:right"
				/>

				<div v-if="readonly && choosen[1] !== undefined">
					{{val.value}}
				</div>
				<p v-if="choosen[1] !== undefined">%</p>
				<span v-if="choosen[1] === undefined" style="width:100px">100 % </span>
				<div v-if="!readonly && choosen.length > 1">
					<v-icon @click="increment(index)" flat >
						add
					</v-icon>
					<v-icon @click="decrement(index)" flat>
						remove
					</v-icon>
				</div>
			</v-layout>
		</v-flex>

		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>
</template>

<script>
	import EgrantyAutocomplete from "../../../genericComponents/EgrantyAutocomplete";
	import OfferButton from "@/view/logged/offer/components/OfferButton";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "ChooseDAC",
		components: {
			EgrantyIconButton,
			EgrantyValidationError,
			EgrantySectionDivider,
			OfferButton,
			EgrantyAutocomplete
		},

		methods: {

			increment(index) {
				this.choosen[index].value++;
				this.editText(index);
			},

			decrement(index) {
				this.choosen[index].value--;
				this.editText(index);
			},

			deleteElem(index) {
				this.choosen.splice(index, 1);
				this.edit(-1);
			},

			add(val) {
				this.error = "";
				if (this.choosen.indexOf(val) === -1) {
					this.choosen.push(val);
					let index = this.possibilities.findIndex(x => x.id === val.id);
					this.$delete(this.possibilities, index);
					this.$set(this.choosen[this.choosen.length - 1], 'value', 0);
					if (this.choosen.length === 1) {
						this.choosen[this.choosen.length - 1].value = 100;
					}
				}
				this.addDacOpen = false;
				this.sync();
			},

			clear() {
				var self = this;
				this.choosen.forEach(item => {
					self.$delete(item, "value");
					self.possibilities.push(item);
				});
				this.possibilities = this.possibilities.slice().sort((item1, item2) => parseInt(item1.code, 10) - parseInt(item2.code, 10));
				this.choosen = [];

				this.sync();
			},

			sync() {
				this.$emit('input', this.choosen);
			},

			edit(index) {
				let last = this.choosen.length - 1;
				let fundings = this.choosen;

				//wartość, o którą musimy zmienić sumę sliderów
				let excess = -100;
				for (var i = 0; i < fundings.length; i++) {
					excess += fundings[i].value;
				}


				for (i = last; i >= 0; i--) {
					//nie ruszamy wartości slidera, który jest aktualnie edytowany
					if (i === index) {
						continue;
					}
					let change = Math.min(fundings[i].value, excess);
					fundings[i].value -= change;
					excess -= change;
				}
				this.sync();
			},

			editText(index) {
				let last = this.choosen.length - 1;
				if (this.choosen[index].value === "" || isNaN(this.choosen[index].value)) {
					this.choosen[index].value = 0;
				} else {
					this.choosen[index].value = parseInt(this.choosen[index].value, 10);
					if (this.choosen[index].value > 100) {
						this.choosen[index].value = 100;
					}
				}
				let fundings = this.choosen;

				//wartość, o którą musimy zmienić sumę sliderów
				let excess = -100;
				for (var i = 0; i < fundings.length; i++) {
					excess += fundings[i].value;
				}


				for (i = last; i >= 0; i--) {
					//nie ruszamy wartości slidera, który jest aktualnie edytowany
					if (i === index) {
						continue;
					}
					let change = Math.min(fundings[i].value, excess);
					fundings[i].value -= change;
					excess -= change;
				}
				this.sync();
			},

			validate() {
				if (this.choosen.length === 0) {
					this.error = "Proszę dodać co najmniej jeden kod DAC";
				}
				return this.error === "";
			},

			filterPossibilities() {
				this.possibilities = this.possibilities.filter(x => !this.choosen.find(y => x.code === y.code));
			}

		},

		data() {
			return {
				error: "",
				addDacOpen: false,
				possibilities: [],
				choosen: [],
				headers: {
					code: "kod",
					description: "opis"
				},
				filters: {
					id: false
				}
			};
		},

		// watch: {
			// value: {
			// 	immediate: true,
			// 	handler(val) {
			// 		if (val !== undefined) {
			// 			this.choosen = val;
			// 			this.filterPossibilities();
			// 		}
			// 	}
			// },
			// // contestId: {
			// 	immediate: true,
			// 	handler(val) {
			// 		if (this.type === 'PUBLIC_CONTEST') {
			// 			PublicContest.getDacCodes(this, this.contestId, response => {
			// 				this.possibilities = response;
			// 				this.filterPossibilities();
			// 			});
			// 		}

			// 		if (this.type === 'AGENCY_CONTEST') {
			// 			AgencyContest.getDacCodes(this, this.contestId, response => {
			// 				this.possibilities = response;
			// 				this.filterPossibilities();
			// 			});
			// 		}
			// 	}
			// }
		// },

		props: {
			value: Array,
			contestId: null,
			type: {
				type: String
			},
			readonly: {
				type: Boolean, default: false
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},

		mounted() {
		}
	};
</script>

<style scoped>
	.choose-dac button {
		margin-top: 20px;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type=number] {
		-moz-appearance:textfield;
	}

	.v-icon {
		color: #fff;
	}
</style>
